import loadingReducer from "../features/loading";
import loggedInReducer from "../features/loggedIn";
import subscribedReducer from "../features/subscribed";
import sidereducer from "../features/sidebarshift";

export default {
  loadingReducer,
  loggedInReducer,
  subscribedReducer,
  sidereducer,
};